import { Box, Skeleton } from "@avenue-8/sidekick-ui";

export const PresentationSkeleton = () => (
  <Box p={3} display="flex" flexDirection="column" alignItems="center" gap={3}>
    <Skeleton variant="rounded" width="100%" height={80} />
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      width="100%"
      maxWidth={1200}
    >
      <Skeleton variant="rounded" width="35%" height={60} />
      <Skeleton variant="rounded" width="75%" height={40} />
      <Skeleton variant="rounded" width="100%" height={400} />
      <Skeleton variant="rounded" width="40%" height={100} />
      <Box mt={3} display="flex" gap={2} width="100%">
        <Skeleton variant="rounded" width="100%" height={160} />
        <Skeleton variant="rounded" width="100%" height={160} />
        <Skeleton variant="rounded" width="100%" height={160} />
      </Box>
      <Skeleton variant="rounded" width="100%" height={500} />
      <Skeleton variant="rounded" width="100%" height={500} />
      <Skeleton variant="rounded" width="100%" height={850} />
      <Skeleton variant="rounded" width="100%" height={450} />
      <Skeleton variant="rounded" width="100%" height={550} />
      <Skeleton variant="rounded" width="100%" height={500} />
      <Skeleton variant="rounded" width="100%" height={200} />
    </Box>
  </Box>
);
